export default __webpack_public_path__ + "static/N0054-4e68d53dfa82a5a70cd992485eabb66b.png";